export enum ECategory {
  LOCAL = 'LOCAL',
  DIASPORA = 'DIASPORA'
}
